module.exports = __webpack_public_path__ + "static/media/gcs-velogic.fb40be89.png";